import { render, staticRenderFns } from "./medidas-correctivas-mejora.vue?vue&type=template&id=b060f29c&"
import script from "./medidas-correctivas-mejora.vue?vue&type=script&lang=js&"
export * from "./medidas-correctivas-mejora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports